/**
 * Mock data for development and testing
 */

// Farm zones data
export const mockZones = [
  {
    id: 'zone-1',
    name: 'North Field',
    area: 2.5, // hectares
    plantingDate: '2025-03-15',
    variety: 'Albion',
    status: 'active',
    location: {
      lat: 37.7749,
      lng: -122.4194
    },
    image: 'https://images.unsplash.com/photo-1626269555515-4f8a7a8a7f5a',
    description: 'Primary strawberry field with drip irrigation system'
  },
  {
    id: 'zone-2',
    name: 'South Field',
    area: 1.8, // hectares
    plantingDate: '2025-04-01',
    variety: 'Monterey',
    status: 'active',
    location: {
      lat: 37.7739,
      lng: -122.4312
    },
    image: 'https://images.unsplash.com/photo-1626269555515-4f8a7a8a7f5a',
    description: 'Secondary field with newer plants and experimental irrigation'
  },
  {
    id: 'zone-3',
    name: 'East Greenhouse',
    area: 0.5, // hectares
    plantingDate: '2025-02-10',
    variety: 'Seascape',
    status: 'active',
    location: {
      lat: 37.7831,
      lng: -122.4039
    },
    image: 'https://images.unsplash.com/photo-1626269555515-4f8a7a8a7f5a',
    description: 'Controlled environment for early season varieties'
  }
];

// Zone metrics data
export const mockZoneMetrics = {
  'zone-1': {
    moisture: [
      { timestamp: '2025-06-24T08:00:00', value: 68 },
      { timestamp: '2025-06-24T09:00:00', value: 67 },
      { timestamp: '2025-06-24T10:00:00', value: 65 },
      { timestamp: '2025-06-24T11:00:00', value: 64 },
      { timestamp: '2025-06-24T12:00:00', value: 62 },
      { timestamp: '2025-06-24T13:00:00', value: 63 },
      { timestamp: '2025-06-24T14:00:00', value: 65 },
      { timestamp: '2025-06-24T15:00:00', value: 68 },
      { timestamp: '2025-06-24T16:00:00', value: 70 },
      { timestamp: '2025-06-24T17:00:00', value: 71 },
      { timestamp: '2025-06-25T08:00:00', value: 69 },
    ],
    temperature: [
      { timestamp: '2025-06-24T08:00:00', value: 18 },
      { timestamp: '2025-06-24T09:00:00', value: 19 },
      { timestamp: '2025-06-24T10:00:00', value: 21 },
      { timestamp: '2025-06-24T11:00:00', value: 23 },
      { timestamp: '2025-06-24T12:00:00', value: 25 },
      { timestamp: '2025-06-24T13:00:00', value: 26 },
      { timestamp: '2025-06-24T14:00:00', value: 25 },
      { timestamp: '2025-06-24T15:00:00', value: 24 },
      { timestamp: '2025-06-24T16:00:00', value: 22 },
      { timestamp: '2025-06-24T17:00:00', value: 20 },
      { timestamp: '2025-06-25T08:00:00', value: 19 },
    ],
    nutrients: {
      nitrogen: [
        { timestamp: '2025-06-24T08:00:00', value: 45 },
        { timestamp: '2025-06-25T08:00:00', value: 43 },
      ],
      phosphorus: [
        { timestamp: '2025-06-24T08:00:00', value: 32 },
        { timestamp: '2025-06-25T08:00:00', value: 31 },
      ],
      potassium: [
        { timestamp: '2025-06-24T08:00:00', value: 38 },
        { timestamp: '2025-06-25T08:00:00', value: 37 },
      ],
      ph: [
        { timestamp: '2025-06-24T08:00:00', value: 6.2 },
        { timestamp: '2025-06-25T08:00:00', value: 6.3 },
      ]
    }
  },
  'zone-2': {
    moisture: [
      { timestamp: '2025-06-24T08:00:00', value: 72 },
      { timestamp: '2025-06-24T09:00:00', value: 71 },
      { timestamp: '2025-06-24T10:00:00', value: 70 },
      { timestamp: '2025-06-24T11:00:00', value: 68 },
      { timestamp: '2025-06-24T12:00:00', value: 67 },
      { timestamp: '2025-06-24T13:00:00', value: 66 },
      { timestamp: '2025-06-24T14:00:00', value: 68 },
      { timestamp: '2025-06-24T15:00:00', value: 69 },
      { timestamp: '2025-06-24T16:00:00', value: 71 },
      { timestamp: '2025-06-24T17:00:00', value: 72 },
      { timestamp: '2025-06-25T08:00:00', value: 73 },
    ],
    temperature: [
      { timestamp: '2025-06-24T08:00:00', value: 17 },
      { timestamp: '2025-06-24T09:00:00', value: 18 },
      { timestamp: '2025-06-24T10:00:00', value: 20 },
      { timestamp: '2025-06-24T11:00:00', value: 22 },
      { timestamp: '2025-06-24T12:00:00', value: 24 },
      { timestamp: '2025-06-24T13:00:00', value: 25 },
      { timestamp: '2025-06-24T14:00:00', value: 24 },
      { timestamp: '2025-06-24T15:00:00', value: 23 },
      { timestamp: '2025-06-24T16:00:00', value: 21 },
      { timestamp: '2025-06-24T17:00:00', value: 19 },
      { timestamp: '2025-06-25T08:00:00', value: 18 },
    ],
    nutrients: {
      nitrogen: [
        { timestamp: '2025-06-24T08:00:00', value: 48 },
        { timestamp: '2025-06-25T08:00:00', value: 47 },
      ],
      phosphorus: [
        { timestamp: '2025-06-24T08:00:00', value: 35 },
        { timestamp: '2025-06-25T08:00:00', value: 34 },
      ],
      potassium: [
        { timestamp: '2025-06-24T08:00:00', value: 41 },
        { timestamp: '2025-06-25T08:00:00', value: 40 },
      ],
      ph: [
        { timestamp: '2025-06-24T08:00:00', value: 6.5 },
        { timestamp: '2025-06-25T08:00:00', value: 6.4 },
      ]
    }
  }
};

// Weather data
export const mockCurrentWeather = {
  timestamp: '2025-06-25T08:00:00',
  temperature: 19,
  condition: 'Partly Cloudy',
  humidity: 65,
  windSpeed: 8,
  windDirection: 'NW',
  precipitation: 0,
  icon: 'partly-cloudy'
};

export const mockForecast = [
  {
    date: '2025-06-25',
    high: 24,
    low: 16,
    condition: 'Partly Cloudy',
    precipitation: 10,
    icon: 'partly-cloudy'
  },
  {
    date: '2025-06-26',
    high: 26,
    low: 17,
    condition: 'Sunny',
    precipitation: 0,
    icon: 'sunny'
  },
  {
    date: '2025-06-27',
    high: 25,
    low: 18,
    condition: 'Sunny',
    precipitation: 0,
    icon: 'sunny'
  },
  {
    date: '2025-06-28',
    high: 23,
    low: 17,
    condition: 'Cloudy',
    precipitation: 20,
    icon: 'cloudy'
  },
  {
    date: '2025-06-29',
    high: 22,
    low: 16,
    condition: 'Light Rain',
    precipitation: 60,
    icon: 'rain'
  },
  {
    date: '2025-06-30',
    high: 21,
    low: 15,
    condition: 'Showers',
    precipitation: 70,
    icon: 'rain'
  },
  {
    date: '2025-07-01',
    high: 23,
    low: 16,
    condition: 'Partly Cloudy',
    precipitation: 20,
    icon: 'partly-cloudy'
  }
];

// Agent recommendations
export const mockRecommendations = [
  {
    id: 'rec-1',
    zoneId: 'zone-1',
    timestamp: '2025-06-25T07:30:00',
    type: 'irrigation',
    priority: 'high',
    title: 'Increase Irrigation',
    description: 'Soil moisture levels have dropped below optimal range. Increase irrigation by 15% for the next three days to maintain optimal moisture levels.',
    reasoning: 'Current soil moisture is at 69% (optimal range is 70-75%). With forecasted temperatures of 24-26°C and no precipitation expected for the next 3 days, moisture levels will continue to decrease without intervention.',
    actionable: true
  },
  {
    id: 'rec-2',
    zoneId: 'zone-1',
    timestamp: '2025-06-24T16:45:00',
    type: 'nutrient',
    priority: 'medium',
    title: 'Apply Nitrogen Supplement',
    description: 'Nitrogen levels are trending downward. Apply organic nitrogen supplement within the next 5 days.',
    reasoning: 'Current nitrogen level is at 43% (optimal range is 45-55%). Plants are entering fruiting stage which requires higher nitrogen uptake.',
    actionable: true
  },
  {
    id: 'rec-3',
    zoneId: 'zone-2',
    timestamp: '2025-06-25T07:45:00',
    type: 'pest',
    priority: 'medium',
    title: 'Monitor for Aphids',
    description: 'Weather conditions are favorable for aphid development. Increase monitoring frequency and consider preventive measures.',
    reasoning: 'Current temperature and humidity levels create ideal conditions for aphid population growth. Early detection can prevent significant damage.',
    actionable: true
  }
];

// Tasks
export const mockTasks = [
  {
    id: 'task-1',
    title: 'Increase irrigation in North Field',
    description: 'Adjust drip irrigation system to increase water flow by 15%',
    zoneId: 'zone-1',
    status: 'pending',
    priority: 'high',
    dueDate: '2025-06-25T17:00:00',
    createdAt: '2025-06-25T07:30:00',
    createdBy: 'ai',
    assignedTo: 'user',
    relatedRecommendationId: 'rec-1'
  },
  {
    id: 'task-2',
    title: 'Apply nitrogen supplement to North Field',
    description: 'Apply 2kg/hectare of organic nitrogen fertilizer',
    zoneId: 'zone-1',
    status: 'pending',
    priority: 'medium',
    dueDate: '2025-06-29T17:00:00',
    createdAt: '2025-06-24T16:45:00',
    createdBy: 'ai',
    assignedTo: 'user',
    relatedRecommendationId: 'rec-2'
  },
  {
    id: 'task-3',
    title: 'Inspect South Field for aphids',
    description: 'Check undersides of leaves for aphid presence, particularly in younger plants',
    zoneId: 'zone-2',
    status: 'pending',
    priority: 'medium',
    dueDate: '2025-06-26T17:00:00',
    createdAt: '2025-06-25T07:45:00',
    createdBy: 'ai',
    assignedTo: 'user',
    relatedRecommendationId: 'rec-3'
  },
  {
    id: 'task-4',
    title: 'Harvest ripe strawberries in North Field',
    description: 'Harvest fully red berries, leaving any with white areas to ripen further',
    zoneId: 'zone-1',
    status: 'completed',
    priority: 'high',
    dueDate: '2025-06-24T17:00:00',
    createdAt: '2025-06-23T08:00:00',
    completedAt: '2025-06-24T15:30:00',
    createdBy: 'user',
    assignedTo: 'user',
    relatedRecommendationId: null
  }
];

// Export all mock data
export const mockData = {
  zones: mockZones,
  zoneMetrics: mockZoneMetrics,
  currentWeather: mockCurrentWeather,
  forecast: mockForecast,
  recommendations: mockRecommendations,
  tasks: mockTasks
};
